import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

// 增强版 replacer
const superReplacer = (key, value) => {
  // 提前拦截不可序列化的类型
  if (
    value instanceof MediaStream ||
    value instanceof Function ||
    value instanceof Event ||
    value instanceof HTMLElement ||
    typeof value === 'symbol'
  ) {
    return undefined
  }

  // 处理循环引用
  const seen = new WeakSet()
  const checkCircular = (val) => {
    if (val && typeof val === 'object') {
      if (seen.has(val)) {
        console.warn(`[vuex-persist] 检测到循环引用，跳过属性: ${key}`)
        return undefined
      }
      seen.add(val)
    }
    return val
  }

  return checkCircular(value)
}

// 安全转换函数
const safeData = (data) => {
  try {
    return JSON.parse(JSON.stringify(data, superReplacer))
  } catch (e) {
    console.error('数据清理失败:', e)
    return {}
  }
}

const vuexPersist = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    isStartClass: state.isStartClass,
    boardFileId: state.boardFileId,
    classInfo: safeData(state.classInfo), // 深度清理
    // isRoomOperation: state.isRoomOperation,
    reportInfo: safeData(state.reportInfo),
    trialReportId: safeData(state.trialReportId),
    // showDialogList: safeData(state.showDialogList),
    // 明确排除 localStream
  }),
  replacer: superReplacer
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isStartClass: 0,
    boardFileId: '',
    classInfo: {},
    localStream: {
      deviceID:'',
      audioID:''
    },
    isRoomOperation: false,
    reportInfo: {},
    trialReportId: '',
    countMessage: 0,
    showDialogList: [],
    stuHomeDate: new Date(),
    currentFolderName: '',
    flowClassTest:[],
    zgInfo:{},
    shareQuesData:{
      isShare:false,
    },
  },
  mutations: {
    changeIsStartClass(state, payload) {
      state.isStartClass = payload
    },
    changeBoardFileId(state, payload) {
      state.boardFileId = payload
    },
    changeClassInfo(state, payload) {
      state.classInfo = safeData(payload) // 存入前清理
    },
    changeLocalStreamDeviceID(state, payload) {
      state.localStream.deviceID = payload // 不参与持久化
    },
     changeLocalStreamAudioID(state, payload) {
      state.localStream.audioID = payload // 不参与持久化
    },
    changeIsRoomOperation(state, payload) {
      state.isRoomOperation = payload
    },
    changeReportInfo(state, payload) {
      state.reportInfo = safeData(payload) // 存入前清理
    },
    changeTrialReportId(state, payload) {
      state.trialReportId = safeData(payload) // 存入前清理
    },
    changeCountMessage(state, payload) {
      state.countMessage = payload
    },
    changeShowDialgList(state, payload) {
      state.showDialogList = payload // 存入前清理
    },
    updateFolderName(state, payload) {
      state.currentFolderName = payload;
    },
    changeStuHomeDate(state, payload) {
      state.stuHomeDate = payload // 存入前清理
    },
    flowClassTestData(state, payload){
      state.flowClassTest = payload
    },
    changeZgInfo(state, payload){
      state.zgInfo = payload
    },
    changeShareQuesData(state, payload){
      state.shareQuesData = payload
    }
  },
  plugins: [vuexPersist.plugin]
})
